import { useEffect, useState } from "react";
import { TemplateFieldsIProps } from "../model/schema";
import { useQuery } from "react-query";
import { useTemplate } from "./useTemplate";

export const useGetTemplateFields = () => {
  const [dataList, setDataList] = useState<TemplateFieldsIProps>();
  const { getTemplateFields } = useTemplate();

  const { data } = useQuery({
    queryKey: ["getTemplateFields"],
    queryFn: () => getTemplateFields(),
    refetchOnWindowFocus: false,
    enabled: true,
  });

  useEffect(() => {
    if (data?.data && data?.status >= 200 && data?.status < 300) {
      setDataList(data.data);
    }
  }, [data]);

  return { data: dataList };
};
